import React from 'react'
import BrandListContainer from '../../../../Components/Brand/BrandListContainer/BrandListContainer'
import Layout from '../../Layout'

const BrandList = () => {
  return (
    <Layout><BrandListContainer/></Layout>
  )
}

export default BrandList